export enum IframeMode {
  NONE = 'NONE',      // Standalone app
  WIDGET = 'WIDGET',  // Widget iframe (launched by button)
  INLINE = 'INLINE'   // Dealer's own iframe (auto-open)
}
